import { Component, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';

import { Link } from '../../../../business/link/link';
import { LinkService } from '../../../../services/link.service';
import { SelectorUniverseEnum } from '../selector-universe.enum';

@Component({
    selector: 'ecm-selector-rebound-links',
    templateUrl: 'selector-rebound-links.html',
})
export class SelectorReboundLinksComponent {
    /**
     * Universe parameter
     * @type {SelectorUniverseEnum}
     */
    @Input() public universe: SelectorUniverseEnum;

    public constructor(
        private translateService: TranslateService,
        private linkService: LinkService,
    ) {
        translateService.use('i18n');
    }

    /**
     * Get link url
     * @param {Link} link
     * @returns {Observable<string>}
     */
    public getLink(link: Link): Observable<string> {
        const params = new Map();
        params.set('{{currentLink}}', encodeURIComponent(window.location.toString()));
        return this.linkService.getLink(link, params);
    }

    /**
     * Open link
     * @param {Link} link
     */
    public openLink(link: Link): void {
        const params = new Map();
        params.set('{{currentLink}}', encodeURIComponent(window.location.toString()));
        this.linkService.openLink(
            link,
            {
                featureName: '',
                functionality: '',
                tmsTracking: {
                    trackedPage: this.universe,
                    trackingArea: SelectorUniverseEnum.CONTRACT,
                    trackingName: this.universe,
                    targetUrl: 'NR',
                },
            },
            params,
            null,
            true,
        );
    }
}
